import React from "react";
import { connect } from "react-redux";
import Cookies from "universal-cookie";

import { registrarFeriado, editarFeriado } from "./FeriadoService.js";
import PantallaCarga from "../mensajeFlash/PantallaCarga";
import { validateForm } from "../../constans/validationUtils";
import BreadCrumComponent from "../../components/componentes/BreadCrumComponent";
import {
  mostrarErroresEnFormulario,
  configurarLimpiezaAutomatica,
  integrarConHandleInput,
} from "../../constans/form-error-utils";

class Feriado extends React.Component {
  constructor(props) {
    super(props);

    const { tipoAccion } = props.match.params;

    const originalHandleInput = this.handleInput;
    this.handleInput = integrarConHandleInput(this, originalHandleInput);

    this.state = {
      dia: "",
      mes: "",
      anio: new Date().getFullYear(),
      descripcion: "",
      id: "",

      errors: {
        dia: null,
        mes: null,
        anio: null,
        descripcion: null,
      },

      openPantallaCarga: false,
      tipoAccion,
      titulo: null,
    };
  }

  cookies = new Cookies();

  // Validaciones (alineadas a tu entity)
  reglasValidacionCampos = {
    dia: [
      { required: true, message: "Ingrese el día" },
      {
        customValidator: (value) => /^\d+$/.test(String(value)),
        message: "Ingrese un día válido",
      },
      {
        customValidator: (value) => Number(value) >= 1 && Number(value) <= 31,
        message: "El día debe estar entre 1 y 31",
      },
    ],
    mes: [
      { required: true, message: "Ingrese el mes" },
      {
        customValidator: (value) => /^\d+$/.test(String(value)),
        message: "Ingrese un mes válido",
      },
      {
        customValidator: (value) => Number(value) >= 1 && Number(value) <= 12,
        message: "El mes debe estar entre 1 y 12",
      },
    ],
    anio: [
      { required: true, message: "Ingrese el año" },
      {
        customValidator: (value) => /^\d+$/.test(String(value)),
        message: "Ingrese un año válido",
      },
      {
        customValidator: (value) => Number(value) >= 1900 && Number(value) <= 2500,
        message: "Ingrese un año válido",
      },
    ],
    descripcion: [{ required: true, message: "Ingrese una descripción" }],
  };

  componentDidMount() {
    configurarLimpiezaAutomatica();

    if (this.state.tipoAccion === "edit") {
      const { feriado } = this.props.location.state || {};
      if (feriado) {
        this.setState({
          dia: feriado.dia,
          mes: feriado.mes,
          anio: feriado.anio,
          descripcion: feriado.descripcion,
          id: feriado.id,
          titulo: "Datos de " + (feriado.descripcion || "feriado"),
        });
      }
    } else {
      // Si querés pre-cargar el año actual desde donde venís (listado)
      const state = this.props.location.state || {};
      if (state.anio) {
        this.setState({ anio: state.anio });
      }
    }
  }

  handleInput = (e) => {
    const name = e.target.name;
    const val = e.target.value;

    this.setState((prevState) => ({
      errors: {
        ...prevState.errors,
        [name]: null,
      },
      [name]: val,
    }));
  };

  handleSubmit = (event) => {
    event.preventDefault();

    const { isValid, errors } = validateForm(this.state, this.reglasValidacionCampos);

    if (!isValid) {
      this.setState({ errors, showErrors: true });
      mostrarErroresEnFormulario(errors);
      return;
    }

    mostrarErroresEnFormulario({});
    this.setState({ openPantallaCarga: true });

    const idEmpresa = this.cookies.get("empresa"); // igual que en tus otras pantallas

    const payload = {
      dia: Number(this.state.dia),
      mes: Number(this.state.mes),
      anio: Number(this.state.anio),
      descripcion: this.state.descripcion,
      // idEmpresa lo mandamos aparte (según cómo armamos el backend: requestParam)
    };

    if (this.state.tipoAccion === "edit") {
      this.props.editarFeriado(this.state.id, payload).then((response) => {
        this.props.history.push({
          pathname: `/configuracion/feriados`,
          state: {
            mensajeFlash: response.mensaje,
            mostrarMensajeFlash: true,
            mensajeFlashSeverity: response.error ? "error" : "exito",
          },
        });
      });
    } else {
      this.props.registrarFeriado(payload).then((response) => {
        this.props.history.push({
          pathname: `/configuracion/feriados`,
          state: {
            mensajeFlash: response.mensaje,
            mostrarMensajeFlash: true,
            mensajeFlashSeverity: response.error ? "error" : "exito",
          },
        });
      });
    }
  };

  render() {
    const esEdit = this.props.match.params.tipoAccion === "edit";

    return (
      <div>
        <div className="template-base">
          <header className="component-header">
            <div className="page-container">
              <BreadCrumComponent
                backUrl={"/configuracion/feriados"}
                breadcrumbs={[
                  { label: "Configuraciones", path: "/configuracion/tipo-documento" },
                  { label: "Feriados", path: "/configuracion/feriados" },
                  {
                    label: !esEdit ? "Registrar feriado" : "Editar feriado",
                    path: "",
                  },
                ]}
              />

              <div className="head-area">
                <div className="caption-area">
                  <h1 className="page-title">
                    {this.state.titulo ?? (!esEdit ? "Registrar nuevo feriado" : "Editar feriado")}
                  </h1>
                  <p className="page-description">
                    Complete el siguiente formulario con los datos solicitados
                  </p>
                </div>
              </div>
            </div>
          </header>

          <div className="wrapperContent">
            <div className="page-container">
              <div className="component-content card">
                <form onSubmit={this.handleSubmit} className="form container-sm">
                  <div className="form-group">
                    <input
                      type="number"
                      name="dia"
                      id="dia"
                      className="form-input"
                      onChange={this.handleInput}
                      value={this.state.dia}
                    />
                    <label htmlFor="dia" className="form-label">
                      Día
                    </label>
                  </div>

                  <div className="form-group">
                    <input
                      type="number"
                      name="mes"
                      id="mes"
                      className="form-input"
                      onChange={this.handleInput}
                      value={this.state.mes}
                    />
                    <label htmlFor="mes" className="form-label">
                      Mes
                    </label>
                  </div>

                  <div className="form-group">
                    <input
                      type="number"
                      name="anio"
                      id="anio"
                      className="form-input"
                      onChange={this.handleInput}
                      value={this.state.anio}
                    />
                    <label htmlFor="anio" className="form-label">
                      Año
                    </label>
                  </div>

                  <div className="form-group">
                    <input
                      type="text"
                      name="descripcion"
                      id="descripcion"
                      className="form-input"
                      onChange={this.handleInput}
                      value={this.state.descripcion}
                    />
                    <label htmlFor="descripcion" className="form-label">
                      Descripción
                    </label>
                  </div>

                  <div className="form-actions">
                    <button type="submit" className="btn-medium btn-primary">
                      GUARDAR
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <PantallaCarga open={this.state.openPantallaCarga} />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  registrarFeriado: (payload) => dispatch(registrarFeriado(payload)),
  editarFeriado: (id, payload) => dispatch(editarFeriado(id, payload)),
});

export default connect(null, mapDispatchToProps)(Feriado);
